import * as types from '../mutations'
import Vue from 'vue'
import axios from 'axios'

const state = {
    categories: [],
    categoriesFetched: false,
}

function findById(id, arr)
{
    for (let i = 0; i < arr.length; ++i)
    {
        if (arr[i].id === id)
        {
            return { index: i, obj: arr[i]}
        }
    }
    return null
}

const mutations = {

    [types.ARTISTCATEGORIES_FETCH] (state, list)
    {
        state.categories = list
        state.categoriesFetched = true
    },

    [types.ARTISTCATEGORIES_ADD] (state, category)
    {
        state.categories.push(category)
    },

    [types.ARTISTCATEGORIES_DELETE] (state, category)
    {
        const result = findById(category.id, state.categories)
        if (result)
        {
            state.categories.splice(result.index, 1)
        }
    },

    [types.ARTISTCATEGORIES_UPDATE] (state, category)
    {
        const result = findById(category.id, state.categories)
        if (result)
        {
            Vue.set(state.categories, result.index, category)
        }
    },

}

const actions = {

    init({rootGetters, dispatch})
    {
        /*
        if (rootGetters.authLoggedIn)
            dispatch('artistCategoryCheck')
        */
    },

    artistCategoryCheck({dispatch, state})
    {
        if (!state.categoriesFetched)
        {
            dispatch('artistCategoryFetch')
        }
    },

    artistCategoryFetch({commit})
    {
        return new Promise(async(resolve, reject) => {
            const list = await axios.get(process.env.API_URL + '/v1/admin/artistcategories')
            if (list)
            {
                commit(types.ARTISTCATEGORIES_FETCH, list.data)
                resolve(list.data)
            } else {
                reject()
            }
        })
    },

    artistCategoryUpdate({commit}, category)
    {
        return new Promise((resolve, reject) => {
            commit(types.ARTISTCATEGORIES_UPDATE, category)
            resolve()
        })
    },

    artistCategoryDelete({commit}, category)
    {
        return new Promise((resolve, reject) => {
            commit(types.ARTISTCATEGORIES_DELETE, category)
            resolve()
        })
    },

    artistCategoryNew({commit}, category)
    {
        return new Promise((resolve, reject) => {
            commit(types.ARTISTCATEGORIES_ADD, category)
            resolve()
        })
    },

}

const getters = {
    artistCatgoriesList: state => JSON.parse(JSON.stringify(state.categories))
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/artistCatgories.js